<div
  class="modal"
  tabindex="-1"
  role="dialog"
  aria-hidden="true"
  data-at="modal-trade"
>
  <div class="modal__content">
    <div class="modal__content__header">
      <div class="navbar navbar--sub">
        <div class="navbar__section navbar__section--title">
          {{ data.title | translate }}
        </div>
        <div class="navbar__section navbar__section--right">
          <gk-help-menu [isSmallIcon]="true" class="tw-mt-2"></gk-help-menu>
          <gk-icon-button icon="close" (buttonClick)="close()"></gk-icon-button>
        </div>
      </div>
    </div>
    <div class="modal__content__body">
      <gk-add-trade-form
        [header]="header"
        [customCashTradeTypeList]="customCashTradeTypeList"
        [tradingTypeList]="tradingTypeList"
        [stockPeriodList]="stockPeriodList"
        [tradingCompanyList]="tradingCompanyList"
        [isMiscTransaction]="isMiscTransaction"
        [isStockTransaction]="isStockTransaction"
        (saveForm)="addTrade()"
        (addNewTradingCompany)="addNewTradingCompany($event)"
        (tradingTypeChange)="onTradingTypeChange($event)"
        (tradingCompanyChange)="onTradingCompanyChange($event)"
      ></gk-add-trade-form>
    </div>
  </div>
</div>
